import { FETCH_CUSTOMER_PROFILE } from 'actions/customer';

const initialState = {
  isLoading: false,
  customerProfile: {},
};
const customerProfileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CUSTOMER_PROFILE.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_CUSTOMER_PROFILE.SUCCESS: {
      return {
        ...state,
        customerProfile: payload,
        isLoading: false,
      };
    }

    case FETCH_CUSTOMER_PROFILE.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
export default customerProfileReducer;
